import React, { useEffect, useRef, useState, } from 'react';
import { Dimensions, FlatList, Image as Img, ScrollView, StyleSheet, Text, TextInput, TouchableOpacity, View, Platform } from 'react-native';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, TypographyTypeDLS, } from '@voltmoney/schema';
import { Icon } from '../icon/Icon';
import { ListBase } from '../list/List.base';
import { HeaderDefaultBase } from '../header/HeaderDefault.Base';
import { addCommasToNumber } from '../stack/utils';
import { Typography } from '../typography/Typography';
import Modal from 'react-native-modal';
import TextField from "./TextField";
import { Button } from "../button/Button";
import { LENDER_ID } from './constants';
import { isFromTDLPlatform } from './utils';
let elssExist = false;
let equityExist = false;
let debtExist = false;
let selectedArray = [];
let selectedMap = {};
let combindedData = [];
let filters = [];
let nonEligibleFilters = [];
let totalEligibleValue = 0;
let totalNonValue = 0;
const eligibleData = [
    {
        isin: 'INF179K01YV8',
        nav: 853.432,
        ltv: 0.45,
        totalValue: 64000,
        eligibleValue: 64000,
        nonEligibleValue: 0,
        creditLimit: 28800,
        schemeName: 'HDFC Top 100 Fund',
        schemeCode: '44T',
        ownershipType: null,
        folioNumber: '21044673',
        amcCode: 'H',
        amcName: 'HDFC Mutual Fund',
        rtaCode: 'CAMS',
        panType: null,
        email: 'luniyaarpit240199@gmail.com',
        mobile: null,
        freeUnits: 75.03,
        blockedUnits: 0,
        blockedSubReason: null,
        blockedReason: null,
    },
    {
        isin: 'INF760K01EL8',
        nav: 134.24,
        ltv: 0.45,
        totalValue: 39200,
        eligibleValue: 39200,
        nonEligibleValue: 0,
        creditLimit: 17600,
        schemeName: 'Canara Robeco Equity Tax Saver ',
        schemeCode: 'ETDGG',
        ownershipType: null,
        folioNumber: '19922546862',
        amcCode: '101',
        amcName: 'Canara Robeco Mutual Fund',
        rtaCode: 'KARVY',
        panType: null,
        email: 'luniyaarpit240199@gmail.com',
        mobile: null,
        freeUnits: 292.52,
        blockedUnits: 0,
        blockedSubReason: null,
        blockedReason: null,
    },
];
// const mData = {
// 	overallSummary: {
// 		nonEligibleFundsSummary: {
// 			LOCKED: {
// 				KARVY: 77900,
// 			},
// 		},
// 		eligibleFundsSummary: {
// 			KARVY: 39300,
// 			CAMS: 64100,
// 		},
// 		totalFundsSummary: {
// 			KARVY: 117200,
// 			CAMS: 64100,
// 		},
// 		eligibleCreditLimit: {
// 			KARVY: 17700,
// 			CAMS: 0,
// 		},
// 	},
// 	eligibleAssetData: {
// 		MUTUAL_FUND: [
// 			{
// 				isin: 'INF179K01YV8',
// 				nav: 854.609,
// 				ltv: 0,
// 				totalValue: 64100,
// 				eligibleValue: 64100,
// 				nonEligibleValue: 0,
// 				creditLimit: 0,
// 				schemeName:
// 					'HDFC Top 100 Fund - Direct Plan - Growth Option (formerly HDFC Top 200 Fund)',
// 				schemeCode: '44T',
// 				ownershipType: null,
// 				folioNumber: '21044673',
// 				amcCode: 'H',
// 				amcName: 'HDFC Mutual Fund',
// 				rtaCode: 'CAMS',
// 				panType: null,
// 				email: 'luniyaarpit240199@gmail.com',
// 				mobile: null,
// 				fundType: 'EQUITY',
// 				freeUnits: 75.03,
// 				blockedUnits: 0,
// 				blockedSubReason: null,
// 				blockedReason: null,
// 			},
// 			{
// 				isin: 'INF760K01EL8',
// 				nav: 134.5,
// 				ltv: 0.45,
// 				totalValue: 39300,
// 				eligibleValue: 39300,
// 				nonEligibleValue: 0,
// 				creditLimit: 17700,
// 				schemeName:
// 					'Canara Robeco Equity Tax Saver Fund - Direct Growth',
// 				schemeCode: 'ETDGG',
// 				ownershipType: null,
// 				folioNumber: '19922546862',
// 				amcCode: '101',
// 				amcName: 'Canara Robeco Mutual Fund',
// 				rtaCode: 'KARVY',
// 				panType: null,
// 				email: 'luniyaarpit240199@gmail.com',
// 				mobile: null,
// 				fundType: 'EQUITY',
// 				freeUnits: 292.52,
// 				blockedUnits: 0,
// 				blockedSubReason: null,
// 				blockedReason: null,
// 			},
// 		],
// 	},
// 	nonEligibleAssetData: {
// 		MUTUAL_FUND: [
// 			{
// 				isin: 'INF769K01DM9',
// 				nav: 36.814,
// 				ltv: 0.45,
// 				totalValue: 77900,
// 				eligibleValue: 0,
// 				nonEligibleValue: 77900,
// 				creditLimit: 0,
// 				schemeName:
// 					'Mirae Asset Tax Saver Fund - Direct Growth',
// 				schemeCode: 'TSD1G',
// 				ownershipType: null,
// 				folioNumber: '79933763606',
// 				amcCode: '117',
// 				amcName: 'Mirae Asset Mutual Fund',
// 				rtaCode: 'KARVY',
// 				panType: null,
// 				email: 'luniyaarpit240199@gmail.com',
// 				mobile: null,
// 				fundType: 'ELSS',
// 				freeUnits: 0,
// 				blockedUnits: 2117.64,
// 				blockedSubReason: 'ELSS_LOCKED',
// 				blockedReason: 'LOCKED',
// 			},
// 		],
// 	},
// 	assetTypeToSummaryMap: {
// 		MUTUAL_FUND: {
// 			nonEligibleFundsSummary: {
// 				LOCKED: {
// 					KARVY: 77900,
// 				},
// 			},
// 			eligibleFundsSummary: {
// 				KARVY: 39300,
// 				CAMS: 64100,
// 			},
// 			totalFundsSummary: {
// 				KARVY: 117200,
// 				CAMS: 64100,
// 			},
// 			eligibleCreditLimit: {
// 				KARVY: 17700,
// 				CAMS: 0,
// 			},
// 		},
// 	},
// };
let mData = {
    eligibleAssetData: undefined,
    nonEligibleAssetData: undefined,
};
const UnpledgeSearch = ({ data, dataa, onPortfolioSelected, creditLimit, flatData, onFitlerSet, isFromEligible, onChangeText, learnWhyAction, totalOutStanding, alreadyPledgedArray, triggerAction, height, onLimitReached, lenderId, extraOutstandingBufferBajaj, extraOutstandingBufferDsp, onMaxMfSelected, onApplyFilter, infoBox, boxNumber, currentActuallimit, currentActualFund, isLimitFull, currentIcinCode, tempCreditResponse, maxCurrentUnpledgeFund, }) => {
    const isfromTDL = isFromTDLPlatform();
    const extraBufferBajaj = (100 + extraOutstandingBufferBajaj) / 100;
    const extraBufferDsp = (100 + extraOutstandingBufferDsp) / 100;
    const bufferTotalOutstanding = lenderId.toLowerCase() === LENDER_ID.BAJAJ.toLowerCase()
        ? Math.ceil(totalOutStanding * extraBufferBajaj)
        : lenderId.toLowerCase() === LENDER_ID.DSP.toLowerCase() ? Math.ceil(totalOutStanding * extraBufferDsp)
            : Math.ceil(totalOutStanding);
    const emojiRegex = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{FE00}-\u{FE0F}\u{1F1E6}-\u{1F1FF}]/gu;
    const [showInfoBox, setShowInfoBox] = useState(infoBox);
    const [boxIndex, setBoxIndex] = useState(boxNumber);
    const [uniqueIsInCode, setUniqueIsInCode] = useState(currentIcinCode);
    const [actualLimit, setActualLimit] = useState(currentActuallimit);
    const [actualFund, setActualFund] = useState(currentActualFund);
    const [maxUnpledgeFund, setMaxUnpledgeFund] = useState(maxCurrentUnpledgeFund);
    const [buttonState, setButtonState] = useState(ButtonTypeTokens.LargeFilled);
    const [showBar, setShowBar] = useState(true);
    const [eligiblePressed, setEligiblePresed] = useState(true);
    const [showFilter, setShowFilter] = useState(false);
    const [flatlistData, setFlatListData] = useState(selectedArray);
    const [itemIndex, setItemIndex] = useState(0);
    const [editedItem, setEditedItem] = useState({});
    const [showEditAmountModal, setShowEditAmountModa,] = useState(false);
    const [limitFull, setLimitFull] = useState(isLimitFull);
    const [extraFlatData, setExtraFlatdata] = useState(dataa);
    const [selectedPledgedList, setSelectedPledgedList,] = useState(data);
    const [pledgedArray, setPledgedArray] = useState(alreadyPledgedArray);
    const [filterData, setFilterData] = useState([]);
    const [selectedList, setSelectedList] = useState(data);
    const [editValue, setEditValue] = useState("");
    const inputRef = useRef(null);
    const [filterName, setFilterName] = useState('EQUITY');
    const [allSelected, setAllSelected] = useState(false);
    useEffect(() => {
        mData = dataa;
        setFlatListData(dataa.eligibleAssetData);
    }, []);
    useEffect(() => {
        if (flatData.length !== 0) {
            setFlatListData(flatData);
        }
    }, [flatData]);
    const addFundsToArray = (item, isinCode) => {
        let tArray = pledgedArray;
        const indexes = pledgedArray.indexOf(item);
        const mainListIndex = flatlistData.indexOf(item);
        if (indexes > -1) {
            let newData = [...flatlistData];
            const index = newData.findIndex((items) => items.isinCode === isinCode);
            if (newData[index].assetOldValue) {
                newData[index] = Object.assign(newData[index], {
                    assetPledgedValue: newData[index].assetOldValue,
                    assetCurrentLimit: newData[index].assetOldValue * newData[index].assetLtv
                });
                setFlatListData(newData);
            }
            tArray.splice(indexes, 1);
            setLimitFull(false);
            setShowInfoBox(false);
            onMaxMfSelected(-1, false, 0, 0);
        }
        else {
            if (limitFull) {
                onLimitReached("ERROR");
                return;
            }
            tArray.push(item);
        }
        if (Math.floor(creditLimit - bufferTotalOutstanding) < 0) {
            return;
        }
        setPledgedArray(tArray);
        let sum = 0;
        let limit = 0;
        for (const asset of tArray) {
            if ((creditLimit - (limit + asset.assetCurrentLimit) > bufferTotalOutstanding || totalOutStanding <= 0)) {
                sum +=
                    Math.floor(asset.assetPledgedValue * 100) /
                        100;
                limit += asset.assetCurrentLimit;
                setShowInfoBox(false);
                onMaxMfSelected(-1, false, 0, 0);
            }
            else {
                onLimitReached("WARNING");
                setShowInfoBox(true);
                setActualLimit(asset.assetCurrentLimit);
                setActualFund(asset.assetPledgedValue);
                setBoxIndex(mainListIndex);
                setUniqueIsInCode(asset.isinCode);
                let newData = [...flatlistData];
                const index = newData.findIndex((items) => items.isinCode === isinCode);
                newData[index] = Object.assign(newData[index], {
                    assetCurrentLimit: Math.floor(creditLimit - limit - bufferTotalOutstanding),
                    assetPledgedValue: Math.floor((creditLimit - limit - bufferTotalOutstanding) / newData[index].assetLtv),
                    assetOldValue: newData[index].assetPledgedValue
                });
                setFlatListData(newData);
                sum +=
                    Math.floor(((creditLimit - limit - bufferTotalOutstanding) / newData[index].assetLtv) * 100) / 100;
                limit +=
                    (Math.floor((creditLimit - limit - bufferTotalOutstanding) * 100) /
                        100);
                setLimitFull(true);
                setMaxUnpledgeFund(sum);
                onMaxMfSelected(mainListIndex, true, asset.assetCurrentLimit, asset.assetPledgedValue, true, asset.isinCode, sum);
                break;
            }
        }
        let pledgedList = selectedPledgedList;
        const index = pledgedList.indexOf(item.isinCode);
        if (index > -1) {
            pledgedList.splice(index, 1);
        }
        else {
            pledgedList.push(item.isinCode);
        }
        setSelectedPledgedList(pledgedList);
        onPortfolioSelected(Math.floor(sum), Math.floor(limit), pledgedArray, selectedList);
        setShowFilter(!showFilter);
    };
    const checkIfExists = (objToCheck, arrayToCheck) => {
        return arrayToCheck.some((item) => JSON.stringify(item) ===
            JSON.stringify(objToCheck));
    };
    const renderItem = ({ item, index }) => {
        return (React.createElement(React.Fragment, null,
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    paddingVertical: 16,
                } },
                React.createElement(View, null,
                    React.createElement(View, { style: {
                            width: Dimensions.get('window').width < 576
                                ? 200
                                : 300,
                            flexDirection: 'row',
                        } },
                        React.createElement(View, { nativeID: 'cb_removePledge_' + (index + 1) },
                            React.createElement(TouchableOpacity, { style: { marginRight: 12 }, onPress: () => {
                                    addFundsToArray(item, item.isinCode);
                                } },
                                React.createElement(Icon, { name: pledgedArray.includes(item)
                                        ? IconTokens.CheckedSquare
                                        : IconTokens.NotCheckedSquare, size: IconSizeTokens.XXL }))),
                        React.createElement(View, { style: { width: Dimensions.get('window').width < 576 ? 200 : 300 } },
                            React.createElement(Typography, { label: item.assetName, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', numberOfLines: 2, lineHeight: 20 }),
                            showInfoBox && boxIndex === index && uniqueIsInCode === item?.isinCode ?
                                React.createElement(Typography, { label: `Limit: ₹${addCommasToNumber(Math.floor(item.assetCurrentLimit))} / ₹${addCommasToNumber(Math.floor(actualLimit))}`, color: ColorTokens.Grey_Charcoal, typeDLS: TypographyTypeDLS.B1R })
                                :
                                    React.createElement(Typography, { label: `Limit: ₹${addCommasToNumber(Math.floor(item.assetCurrentLimit))}`, color: ColorTokens.Grey_Charcoal, typeDLS: TypographyTypeDLS.B1R })))),
                React.createElement(View, { style: {
                        alignItems: 'flex-start',
                        flexDirection: 'row',
                    } },
                    showInfoBox && boxIndex === index && uniqueIsInCode === item?.isinCode ?
                        React.createElement(View, null,
                            React.createElement(Typography, { label: `₹${addCommasToNumber(Math.floor(item.assetPledgedValue))}`, color: ColorTokens.Secondary_100, typeDLS: TypographyTypeDLS.B1S }),
                            React.createElement(Typography, { label: `/ ₹${addCommasToNumber(Math.floor(actualFund))}`, color: ColorTokens.Grey_Charcoal, typeDLS: TypographyTypeDLS.B1R }))
                        :
                            React.createElement(Typography, { label: `₹${addCommasToNumber(Math.floor(item.assetPledgedValue))}`, color: ColorTokens.Secondary_100, typeDLS: TypographyTypeDLS.B1S }),
                    React.createElement(TouchableOpacity, { style: { marginLeft: 8 }, onPress: () => {
                            setEditValue(item.assetPledgedValue);
                            setItemIndex(index);
                            setEditedItem(item);
                            setShowEditAmountModa(true);
                        } },
                        React.createElement(Icon, { name: IconTokens.Edit, color: ColorTokens.Grey_Smoke, size: IconSizeTokens.LG })))),
            showInfoBox && boxIndex === index && uniqueIsInCode === item?.isinCode &&
                React.createElement(View, { style: {
                        marginBottom: 16,
                        paddingHorizontal: 10,
                        paddingVertical: 8,
                        backgroundColor: '#FDF7E7',
                        flexDirection: 'row',
                        alignItems: 'center',
                        borderRadius: 8
                    } },
                    React.createElement(View, { style: { marginRight: 10 } },
                        React.createElement(Icon, { name: IconTokens.Info, color: ColorTokens.Grey_Smoke, size: IconSizeTokens.MD })),
                    React.createElement(View, { style: { marginRight: 16 } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Selected fund value adjusted based on your available limit and dues' })))));
    };
    const ChecklistItem = ({ item, onPress }) => {
        const [isChecked, setIsChecked] = useState(false);
        const handlePress = (item) => {
            setIsChecked(!isChecked);
            handleItemPress(item.isin);
        };
        return (React.createElement(View, { style: {
                paddingVertical: 16,
                paddingLeft: 10,
                paddingRight: 15,
                justifyContent: 'center',
            } },
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    alignContent: 'center',
                } },
                React.createElement(TouchableOpacity, { style: { paddingRight: 2, paddingLeft: 2 }, onPress: () => {
                        let data = selectedList;
                        const index = data.indexOf(item.isin);
                        if (index > -1) {
                            data.splice(index, 1);
                        }
                        else {
                            data.push(item.isin);
                        }
                        setSelectedList(data);
                        if (eligiblePressed) {
                            setFilterData(mData?.eligibleAssetData?.MUTUAL_FUND.filter((item) => item.fundType === filterName));
                        }
                        else {
                            setFilterData(mData?.nonEligibleAssetData?.MUTUAL_FUND.filter((item) => item.blockedReason === filterName));
                        }
                        // switch (filterName) {
                        // 	case 'EQUITY': {
                        // 		setFilterData(
                        // 			combindedData.filter(
                        // 				(item) => item.fundType === 'EQUITY',
                        // 			),
                        // 		);
                        // 		return;
                        // 	}
                        // 	case 'DEBT': {
                        // 		setFilterData(
                        // 			combindedData.filter(
                        // 				(item) => item.fundType === 'DEBT',
                        // 			),
                        // 		);
                        // 		return;
                        // 	}
                        // 	case 'ELSS': {
                        // 		setFilterData(
                        // 			combindedData.filter(
                        // 				(item) => item.fundType === 'ELSS',
                        // 			),
                        // 		);
                        // 		return;
                        // 	}
                        //}
                        // setFilterData(filterData);
                    } },
                    React.createElement(Icon, { name: selectedList.includes(item.isin)
                            ? IconTokens.CheckedSquare
                            : IconTokens.NotCheckedSquare, size: IconSizeTokens.XXL })),
                React.createElement(TouchableOpacity, { style: styles.itemContainer, onPress: () => {
                        handlePress(item);
                    } },
                    React.createElement(Text, { style: {
                            fontFamily: 'Inter',
                            fontSize: 16,
                            color: '#1D2939',
                        } }, item.schemeName)))));
    };
    const handleItemPress = (itemId) => {
        const updatedItems = filterData.map((item) => item.isin === itemId
            ? { ...item, checked: !item.checked }
            : item);
        setFilterData(updatedItems);
    };
    const filterHeader = () => {
        return (React.createElement(View, null,
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    alignItems: 'center',
                    alignContent: 'center',
                    // paddingTop: 11,
                    // paddingBottom: 11,
                    height: 60,
                } },
                React.createElement(TouchableOpacity, { style: { paddingLeft: 12 }, onPress: () => {
                        setAllSelected(!allSelected);
                        let selectedAllList = selectedList;
                        if (allSelected) {
                            const isinKeys = filterData.map((item) => item.isin);
                            const filteredsArray = selectedAllList.filter((value) => !isinKeys.includes(value));
                            setSelectedList(filteredsArray);
                            return;
                        }
                        filterData.map((item) => {
                            selectedAllList.push(item.isin);
                        });
                        setSelectedList(selectedAllList);
                        //
                        // setFilterData(
                        //     combindedData.filter(
                        //         (item) => item.fundType === filterName,
                        //     ),
                        // );
                    } },
                    React.createElement(Icon, { name: allSelected
                            ? IconTokens.CheckedSquare
                            : IconTokens.NotCheckedSquare, size: IconSizeTokens.XXL })),
                React.createElement(TouchableOpacity, { style: styles.itemContainer, onPress: () => {
                    } },
                    React.createElement(Text, { style: [styles.itemText, { width: 200 }], ellipsizeMode: 'tail', numberOfLines: 1 }, 'Select All'))),
            React.createElement(View, { style: {
                    backgroundColor: '#E4E7EC',
                    height: 1,
                } })));
    };
    const applyFilter = () => {
        let filteredData = [];
        onApplyFilter(pledgedArray);
        if (selectedList.length === 0) {
            setFlatListData(mData.eligibleAssetData);
            return;
        }
        if (eligiblePressed) {
            mData.eligibleAssetData.MUTUAL_FUND.map((item) => {
                selectedList.includes(item.isin)
                    ? filteredData.push(item)
                    : null;
            });
        }
        else {
            mData.nonEligibleAssetData.MUTUAL_FUND.map((item) => {
                selectedList.includes(item.isin)
                    ? filteredData.push(item)
                    : null;
            });
        }
        setFlatListData(filteredData);
    };
    const renderListBase = () => {
        return (React.createElement(ListBase, { data: filterData, selectedMap: selectedMap }));
    };
    const renderFilterItem = ({ item }) => {
        return React.createElement(View, null);
    };
    const returnFilter = () => {
        return (React.createElement(View, { style: height
                ? {
                    width: '100%',
                    height: height ? Platform.OS === "ios" ? height - 15 : height : '100%',
                }
                : { width: '100%', flex: 1 } },
            React.createElement(HeaderDefaultBase, { title: 'Filters', isBackButton: true, onPress: () => {
                    onChangeText(false);
                    setShowFilter(false);
                } }),
            React.createElement(View, { style: height
                    ? {
                        flexDirection: 'row',
                        width: '100%',
                        borderTopWidth: 1,
                        borderColor: '#E4E7EC',
                        height: height ? height - 56 : '100%',
                    }
                    : {
                        flexDirection: 'row',
                        width: '100%',
                        borderTopWidth: 1,
                        borderColor: '#E4E7EC',
                    } },
                React.createElement(FlatList, { style: {
                        width: 150,
                        backgroundColor: '#F9FAFB',
                    }, ItemSeparatorComponent: () => (React.createElement(View, { style: {
                            backgroundColor: '#E4E7EC',
                            height: 1,
                        } })), data: eligiblePressed
                        ? filters
                        : nonEligibleFilters, renderItem: ({ item }) => (React.createElement(View, null,
                        React.createElement(TouchableOpacity, { style: {
                                justifyContent: 'center',
                                alignItems: 'flex-start',
                                padding: 20,
                            }, onPress: () => {
                                if (eligiblePressed) {
                                    setFilterData(mData.eligibleAssetData?.MUTUAL_FUND.filter((items) => items.fundType === item));
                                }
                                else {
                                    setFilterData(mData.nonEligibleAssetData?.MUTUAL_FUND.filter((items) => items.blockedReason === item));
                                }
                                setFilterName(item);
                            } }, React.createElement(Typography, { label: item, color: filterName === item
                                ? ColorTokens.Grey_Night
                                : ColorTokens.Grey_Charcoal, fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Inter })))) }),
                React.createElement(View, { style: {
                        width: 1,
                        height: '100%',
                        backgroundColor: '#E4E7EC',
                    } }),
                React.createElement(ScrollView, { style: height
                        ? {
                            height: height - 56,
                            paddingBottom: 100,
                        }
                        : { height: 550 } },
                    filterHeader(),
                    filterData.map((item) => {
                        return (React.createElement(View, null,
                            React.createElement(ChecklistItem, { item: item, onPress: handleItemPress }),
                            React.createElement(View, { style: {
                                    backgroundColor: '#E4E7EC',
                                    height: 1,
                                } })));
                    }))),
            React.createElement(View, { style: {
                    height: Platform.OS === "ios" ? 76 : 56,
                    position: 'absolute',
                    bottom: 0,
                    flexDirection: 'row',
                    backgroundColor: 'white',
                    width: '100%',
                    alignItems: 'center',
                    justifyContent: Dimensions.get('window').width < 576
                        ? 'center'
                        : 'flex-end',
                    borderWidth: 1,
                    borderColor: '#ddd',
                    borderBottomWidth: 0,
                    shadowColor: '#000000',
                    shadowOffset: { width: 0, height: 2 },
                    shadowOpacity: 0.9,
                    shadowRadius: 3,
                    elevation: 5,
                } },
                React.createElement(TouchableOpacity, { onPress: () => {
                        setAllSelected(false);
                        setSelectedList([]);
                        setFilterData(dataa.filter((item) => item.assetSubType === filterName));
                    }, style: {
                        marginRight: 18,
                        borderWidth: 1,
                        borderColor: '#1434CB',
                        backgroundColor: 'white',
                        width: 131,
                        height: 32,
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: 50,
                    } },
                    React.createElement(Typography, { label: 'Reset filter', color: ColorTokens.Primary_100 })),
                React.createElement(TouchableOpacity, { onPress: () => {
                        applyFilter();
                        onChangeText(false);
                        setShowFilter(false);
                    }, style: {
                        marginRight: 30,
                        backgroundColor: '#1434CB',
                        width: 131,
                        height: 32,
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: 50,
                    } },
                    React.createElement(Typography, { label: 'Apply', color: ColorTokens.White })))));
    };
    const checkMaxVal = (itemIndex, val) => {
        let limit = 0;
        let tempArray = [...pledgedArray];
        let maxVal = 0;
        for (const asset of tempArray) {
            if (creditLimit - (limit + asset.assetCurrentLimit) > bufferTotalOutstanding || totalOutStanding <= 0) {
                maxVal = maxVal + asset.assetPledgedValue;
                limit = limit + asset.assetCurrentLimit;
            }
            else {
                maxVal = maxVal + (creditLimit - limit - bufferTotalOutstanding) / asset.assetLtv;
            }
        }
        return maxUnpledgeFund - maxVal + val;
    };
    const isSelected = (item) => {
        const mainListIndex = pledgedArray.indexOf(item);
        if (mainListIndex > -1)
            return true;
        return false;
    };
    const [searchValue, setSearchValue] = useState('');
    return (React.createElement(ScrollView, { style: { height: Platform.OS === "ios" ? height - 15 : height - 262 } },
        React.createElement(View, null,
            React.createElement(TextInput, { nativeID: 'tf_removePledge_searchFunds', style: [styles.input, { borderRadius: isfromTDL ? 8 : 4 }], placeholder: 'Search funds', placeholderTextColor: '#98A2B3', ref: inputRef, value: searchValue, onChangeText: (searchString) => {
                    const updatedString = searchString.replace(emojiRegex, '');
                    setSearchValue(updatedString);
                    if (updatedString.length > 0) {
                        let filteredData = mData.eligibleAssetData.filter(function (item) {
                            return item.assetName
                                .toLowerCase()
                                .includes(updatedString.toLowerCase());
                        });
                        setFlatListData(filteredData);
                        setShowBar(false);
                    }
                    else {
                        setShowBar(true);
                        if (mData.eligibleAssetData.length > 0) {
                            setEligiblePresed(true);
                            setFlatListData(mData.eligibleAssetData);
                        }
                        else {
                            setFlatListData(mData.eligibleAssetData);
                        }
                    }
                }, underlineColorAndroid: 'transparent' }),
            React.createElement(TouchableOpacity, { style: {
                    position: 'absolute',
                    right: 0,
                    marginTop: 25,
                    marginRight: 20,
                }, onPress: () => {
                    if (!showBar) {
                        inputRef.current.clear();
                        setFlatListData(mData.eligibleAssetData);
                        setShowBar(true);
                        if (mData.eligibleAssetData
                            .length > 0) {
                            setEligiblePresed(true);
                            setFlatListData(mData.eligibleAssetData);
                        }
                        else {
                            setFlatListData(mData.eligibleAssetData);
                        }
                    }
                } },
                React.createElement(Icon, { name: showBar
                        ? IconTokens.Search
                        : IconTokens.Cross, size: showBar
                        ? IconSizeTokens.LG
                        : IconSizeTokens.XL, color: ColorTokens.Grey_Smoke }))),
        React.createElement(View, { style: {
                flexDirection: 'row',
                justifyContent: 'space-between',
                marginTop: 15,
            } },
            React.createElement(Typography, { label: flatlistData.length + ' MFs', color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20 }),
            showBar && (React.createElement(View, { style: { flexDirection: 'row' } },
                React.createElement(TouchableOpacity, { onPress: () => {
                        onFitlerSet();
                    } },
                    React.createElement(Typography, { label: 'Filter', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Night, fontWeight: '400', lineHeight: 20 })),
                React.createElement(TouchableOpacity, { onPress: () => {
                        onFitlerSet();
                    } },
                    React.createElement(Img, { style: {
                            width: 20,
                            height: 20,
                            marginLeft: 5,
                        }, source: {
                            uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/filter.png',
                        }, borderRadius: 8 }))))),
        React.createElement(View, { style: {
                flexDirection: 'row',
                justifyContent: 'space-between',
                marginTop: 15,
            } },
            React.createElement(Typography, { label: 'Mutual fund', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XS, color: ColorTokens.Grey_Charcoal, fontWeight: '500', lineHeight: 18 }),
            React.createElement(View, { style: { marginRight: 32 } },
                React.createElement(Typography, { label: 'Fund value', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XS, color: ColorTokens.Grey_Charcoal, fontWeight: '500', lineHeight: 18 }))),
        showFilter && (React.createElement(View, { style: { height: 1 } })),
        !showFilter && (React.createElement(View, { style: { height: 1 } })),
        React.createElement(View, { style: {
                backgroundColor: '#E4E7EC',
                height: 1,
                marginTop: 12,
                // marginBottom: 10,
                width: '100%'
            } }),
        flatlistData.length > 0 ? (React.createElement(FlatList, { data: flatlistData, renderItem: renderItem, refreshing: showFilter, ItemSeparatorComponent: () => (React.createElement(View, { style: {
                    backgroundColor: '#E4E7EC',
                    height: 1,
                } })) })) : (React.createElement(View, { style: {
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 40,
            } },
            React.createElement(Img, { style: { width: 140, height: 140 }, source: {
                    uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/no_investment_1.png',
                }, borderRadius: 8 }),
            React.createElement(View, { style: { marginTop: 12 } },
                React.createElement(Typography, { label: 'No results found' })))),
        React.createElement(Modal, { onBackdropPress: () => {
                setShowEditAmountModa(false);
            }, animationOutTiming: 500, animationInTiming: 500, backdropColor: 'transparent', customBackdrop: React.createElement(TouchableOpacity, { activeOpacity: 1, onPress: () => {
                    setShowEditAmountModa(false);
                }, style: {
                    width: 504,
                    height: height,
                    backgroundColor: '#25252599',
                    justifyContent: 'center',
                    alignSelf: 'center',
                    marginTop: 82,
                } }), isVisible: showEditAmountModal, animationIn: 'zoomInDown', animationOut: 'zoomOutUp' },
            React.createElement(View, { style: styles.modalContent },
                React.createElement(TouchableOpacity, { style: { position: 'absolute', right: 10, top: 10, marginBottom: 12 }, onPress: () => {
                        setShowEditAmountModa(false);
                    } },
                    React.createElement(Icon, { name: IconTokens.Cancel, size: IconSizeTokens.XL })),
                React.createElement(View, null,
                    React.createElement(TextField, { keyboardType: 'number-pad', style: Platform.OS !== 'web' && { minWidth: 276 }, value: editValue !== "" ? Math.floor(parseInt(editValue)).toString() : editValue, onChangeText: (text) => {
                            const parsedValue = parseInt(text);
                            (parsedValue < 4 || text === '') ? setButtonState(ButtonTypeTokens.LargeOutline) : setButtonState(ButtonTypeTokens.LargeFilled);
                            const CheckMaxVal = checkMaxVal(itemIndex, flatlistData[itemIndex].assetPledgedValue);
                            if (!isNaN(parsedValue) && parsedValue >= 0) {
                                if (isSelected(flatlistData[itemIndex]) && showInfoBox) {
                                    if (parseInt(text) <= CheckMaxVal || text === "") {
                                        setEditValue(text);
                                    }
                                }
                                else if (parseInt(text) <= tempCreditResponse[itemIndex].assetPledgedValue || text === "") {
                                    setEditValue(text);
                                }
                            }
                            else if (text === "") {
                                setEditValue(text);
                            }
                        }, holder: "Update amount", label: "Update amount" }),
                    React.createElement(View, { style: { marginTop: 16 } },
                        React.createElement(Button, { label: "Update amount", type: buttonState, width: ButtonWidthTypeToken.FULL, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.MD, onPress: () => {
                                if (flatlistData[itemIndex].assetPledgedValue > parseInt(editValue) && isSelected(flatlistData[itemIndex])) {
                                    setLimitFull(false);
                                }
                                if (editValue !== "") {
                                    let newData = [...flatlistData];
                                    let pledgedData = [...pledgedArray];
                                    let totalUnitsToBePledged = parseInt(editValue) / newData[itemIndex].assetCurrentMarketPrice;
                                    newData[itemIndex] = Object.assign(newData[itemIndex], {
                                        assetPledgedValue: Math.floor(parseInt(editValue)),
                                        assetCurrentLimit: totalUnitsToBePledged * newData[itemIndex].assetLtv * newData[itemIndex].assetCurrentMarketPrice
                                    });
                                    const indexes = pledgedData.indexOf(newData[itemIndex]);
                                    if (indexes > -1) {
                                        let sum = 0;
                                        let limit = 0;
                                        pledgedData[indexes] = Object.assign(pledgedData[indexes], {
                                            assetPledgedValue: Math.floor(parseInt(editValue)),
                                            assetCurrentLimit: totalUnitsToBePledged * newData[itemIndex].assetLtv * newData[itemIndex].assetCurrentMarketPrice
                                        });
                                        for (const asset of pledgedData) {
                                            sum +=
                                                Math.floor(asset.assetPledgedValue * 100) /
                                                    100;
                                            limit += asset.assetCurrentLimit;
                                        }
                                        onPortfolioSelected(Math.floor(sum), Math.floor(limit), pledgedArray, selectedList);
                                    }
                                    setFlatListData(newData);
                                    setPledgedArray(pledgedData);
                                    setShowEditAmountModa(false);
                                }
                            } })))))));
};
const styles = StyleSheet.create({
    input: {
        height: 48,
        width: '100%',
        borderColor: '#98A2B3',
        fontSize: 16,
        borderWidth: 1,
        padding: 10,
        marginTop: 10,
        color: 'black',
    },
    container: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    button: {
        width: 200,
        height: 50,
        backgroundColor: 'blue',
        borderRadius: 10,
        justifyContent: 'center',
        alignItems: 'center',
    },
    modalContainer: {
        position: 'absolute',
        bottom: 0,
        width: 504,
        height: 600 * 0.5,
        backgroundColor: 'white',
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        padding: 20,
        justifyContent: 'flex-end',
    },
    itemContainer: {
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: 2,
        maxWidth: Dimensions.get('window').width < 576
            ? '85%'
            : '90%',
        marginLeft: 8,
    },
    itemText: {
        fontSize: 16,
        marginLeft: 3,
    },
    checkedItemText: {
        textDecorationLine: 'line-through',
    },
    modalContent: {
        backgroundColor: 'white',
        padding: 16,
        justifyContent: 'center',
        alignSelf: 'center',
        alignItems: 'center',
        borderRadius: 8,
        borderColor: 'rgba(0, 0, 0, 0.1)',
        minWidth: 300,
        paddingTop: 38
    },
});
export default UnpledgeSearch;
